import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../services/storage-service';
import { AppUrl } from '../../appUrl';
import { TranslateModule } from '../../shareds/translate/translate.module';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  private router = inject(Router);
  private ac = inject(ActivatedRoute);
  private st = inject(StorageService);

  bookingData = signal<any>(null);
  bookingResult = signal<any>(null);

  ngOnInit() {
    const bd = this.st.getSession('lastBookingData');
    const br = this.st.getSession('lastBookingResult');
    if (bd) this.bookingData.set(JSON.parse(bd));
    if (br) this.bookingResult.set(JSON.parse(br));
  }

  private get uploadBaseUrl(): string {
    const host = window.location.hostname;
    if (host === 'hotel.bookingx.in.th') return 'https://app.bookingx.in.th';
    return 'https://dev.bookingx.in.th';
  }

  get qrCodeSrc(): string {
    const r = this.bookingResult();
    if (!r || !r.paymehtMethod || r.paymehtMethod.qrData == null) return '';
    const qr = `${this.uploadBaseUrl}/uploads/${r.paymehtMethod.qrData ?? ''}`;
    console.log(qr);

    if (!qr) return '';
    if (qr.startsWith('data:') || qr.startsWith('http')) return qr;
    return `data:image/png;base64,${qr}`;
  }


  // get qrcodePaymeny(): string {
  //   return `https://dev.bookingx.in.th/uploads/${this.bookingResult()?.paymehtMethod.qrData}` ?? '-';
  // }

  get merchantName(): string {
    return this.bookingResult()?.merchantName
      ?? this.bookingResult()?.shopName
      ?? this.bookingData()?.branchName
      ?? '-';
  }

  get merchantId(): string {
    return this.bookingResult()?.merchantId
      ?? this.bookingResult()?.shopId
      ?? this.bookingResult()?.referenceId
      ?? this.bookingResult()?.bookingNo
      ?? '-';
  }

  saveQR() {
    const src = this.qrCodeSrc;
    if (!src) return;
    const a = document.createElement('a');
    a.href = src;
    a.download = 'promptpay-qr.png';
    a.click();
  }

  toUpload() {
    this.router.navigate(['/', AppUrl.upload_payment, this.ac.snapshot.params['app-id']]);
  }

  toBack() {
    history.back();
  }
}
